import React from 'react'
import { Pill } from '../../../ui'

const STATUS_CONFIG = {
  TODO: { label: 'todo', tone: 'neutral' },
  IN_PROGRESS: { label: 'in progress', tone: 'info' },
  DONE: { label: 'done', tone: 'success' },
  CANCELLED: { label: 'cancelled', tone: 'danger' },
}

export function StatusChip({ status, onCycle, disabled = false }) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.TODO
  const ariaLabel = `Status: ${config.label}.${disabled ? '' : ' Click to cycle.'}`

  return (
    <Pill
      as="button"
      type="button"
      tone={config.tone}
      onClick={disabled ? undefined : onCycle}
      disabled={disabled}
      aria-disabled={disabled || undefined}
      aria-label={ariaLabel}
      style={{ textTransform: 'lowercase', minWidth: 60, justifyContent: 'center', flexShrink: 0 }}
    >
      {config.label}
    </Pill>
  )
}
